export { BagHandle as default } from './BagHandle';
